// Minimal, dependency-free fallback shown briefly while a lazy-loaded
// route chunk downloads. Kept intentionally tiny so it doesn't add its
// own weight to the initial bundle.
export const RouteFallback = () => (
  <div
    className="d-flex align-items-center justify-content-center w-100"
    style={{ minHeight: "40vh" }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
